import {DataScope} from '../types'

export const checkPermissionAccessByDataScope = (
  countryId: string,
  plantId: string, // requires only plantId format like 0014
  permissionDataScope: Partial<Pick<DataScope, 'countryId' | 'plantId'>>
) => {
  // in dataScope property returned from permissions api, plantCode is called plantId
  if (plantId === permissionDataScope.plantId && countryId === permissionDataScope.countryId) {
    return true
  }
  if (!permissionDataScope.plantId && countryId === permissionDataScope.countryId) {
    return true
  }
  return false
}
